import type { Video } from '../../core/types';
import type { TikTokSource } from './source';

/**
 * The `Video` members the TikTok host accepts, plus the source that names the
 * video. `playsInline` and `poster` are stored and reported but never reach the
 * embed: it always plays inline and draws the video's own cover image.
 *
 * `preload` reaches no TikTok parameter either, but it is not inert: anything
 * but `'none'` has the host bring TikTok's dormant player up with an `autoplay`
 * it then parks (see `shouldBootstrapTikTokEmbed`), which `controls` also opts
 * out of by handing playback to TikTok's own chrome. That buys commands the
 * embed answers, not metadata — TikTok reports a duration of 0 until it plays.
 */
export interface TikTokMediaProps
  extends Pick<
    Video,
    'src' | 'autoplay' | 'defaultMuted' | 'muted' | 'loop' | 'controls' | 'playsInline' | 'preload' | 'poster'
  > {
  source: TikTokSource | null;
}

export const tiktokMediaDefaultProps: TikTokMediaProps = {
  src: '',
  autoplay: false,
  defaultMuted: false,
  muted: false,
  loop: false,
  controls: false,
  playsInline: true,
  preload: 'metadata',
  poster: '',
  source: null,
};
